'use strict';

function MeasurementLayerEditorDirective ($compile, $timeout, $templateCache) {

  var link = function (scope, element, attrs, ctrls) {
    var MeasurementLayerController = ctrls[0];
    var MapCtrl = ctrls[1];
    var activeLayer = MapCtrl.activeLayer;

    if (!MapCtrl) {
      console.warn('Error: No MapCtrl required controller found');
      return;
    }

    // IMPORTANT: Set the bound variable here
    MeasurementLayerController.measurementLayer = activeLayer;
    if (activeLayer && activeLayer.data.properties.style) {
      MeasurementLayerController.activeColor = activeLayer.data.properties.style.color;
    }

    if (activeLayer && activeLayer.data.properties.text) {
      MeasurementLayerController.text = activeLayer.data.properties.text;
    }

    // TODO: Determine error flow (shouldn't happen naturally)
    var template;
    if (activeLayer) {
      template = $templateCache.get(
        'dash/map/measurementLayerEditor/templates/measurementLayerEditor.tpl.html'
      );
    } else {
      template = '<div>NOT ANY ACTIVE LAYER </div>';
    }

    MeasurementLayerController.refreshLayerStyle = function(styleChanges) {
      var layer = MapCtrl.activeLayer;
      MapCtrl.refreshLayerStyle(layer, styleChanges);
    };

    element.html(template);
    $compile(element.contents())(scope);
  };

  return {
    bindToController: true,
    controller: 'MeasurementLayerEditorController',
    controllerAs: 'editorCtrl',
    link: link,
    template : '<div></div>',
    require: ['measurementLayerEditor', '^sbMap']
  };
}

MeasurementLayerEditorDirective.$inject = ['$compile', '$timeout', '$templateCache'];
module.exports = MeasurementLayerEditorDirective;



// WEBPACK FOOTER //
// ./src/app/dash/map/measurementLayerEditor/MeasurementLayerEditorDirective.js